import { route } from 'preact-router';
import { error, success } from '../store/state';
import { crearTecnico } from '../store/actions/user.actions';
import { Shell } from '../layout/Shell';

export function TecnicoFormView() {
  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const payload = Object.fromEntries(fd);
    try {
      await crearTecnico(payload);
      success.value = 'Técnico creado.';
      route('/perfil');
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="perfil">
      <h2>Nuevo técnico</h2>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Nombre</label>
        <input name="nombre" required />
        <label>Email</label>
        <input name="email" type="email" required />
        <label>Contraseña</label>
        <input name="password" type="password" required minLength={6} />
        <label>Teléfono</label>
        <input name="telefono" />
        <label>Zona</label>
        <input name="zona" placeholder="Ej: Zona Norte" />
        <button class="primary" type="submit">
          Crear técnico
        </button>
        <button class="secondary" type="button" onClick={() => route('/perfil')}>
          Cancelar
        </button>
      </form>
    </Shell>
  );
}
